import { detailsBig, h3, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  a,
  a:visited {
    color: ${({ theme }) => theme.colors.primary};
    transition: all 0.2s;

    @media ${({ theme }) => theme.breakpoints.hover} {
      &:hover {
        box-shadow: inset 0px -4px 0px ${({ theme }) => theme.colors.primary};
      }
    }
  }

  a {
    text-decoration: none;
    min-width: 150px;

    &:hover {
      background-color: #124d60;
      color: #fff;
      padding-left: 20px;
        img:first-of-type {
          display: none;
        }
        img:last-of-type {
          display: block;
        }
    }

    @media ${({ theme }) => theme.breakpoints.sm} {
      margin-bottom: 5px;
    }
  }

  a:last-of-type {
    margin-bottom: 40px;
  }
`;

const Link = styled.a``;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #a0a0a0;
  padding: 24px 0px;
  min-height: 150px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 30px 0 0;
  gap: 30px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
    gap: 5px;

    padding: 0 8px;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  border-left: 1px solid ${({ theme }) => theme.colors.border};
  padding: 0 30px 0 80px;
  gap: 20px;
  img:last-of-type {
    display: none;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 0 8px 0 8px;
  }
`;

const ItemText = styled(paragraph)``;

const ItemDate = styled(detailsBig)`
  white-space: nowrap;
`;

const ItemTitle = styled(h3)`
  max-width: 750px;
`;

const Arrow = styled.img`
  height: 27px;
  transition: all 0.2s ease-in-out;
`;

const Button = styled.div`
  margin-bottom: 110px;
  width: 100%;
  display: flex;
  justify-content: end;
  padding-right: 35px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding-right: 10px;
    margin-bottom: 48px;
    justify-content: start;
  }
`;

const S = {
  Wrapper,
  Link,
  ItemWrapper,
  LeftWrapper,
  RightWrapper,
  ItemText,
  ItemDate,
  ItemTitle,
  Arrow,
  Button,
};

export default S;
